module.exports = __webpack_public_path__ + "static/027_001-c9fa238fafbce0ae39d27dbd69a2e71f.jpg";